export const COOKIE_BANNER_SESSION_STORAGE_ID = 'MedalliaCookieBanner';

export default COOKIE_BANNER_SESSION_STORAGE_ID;
